import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {UserService} from '../../../services/user.service';
import {requiredFieldValidator} from '../../../validators/required-field-validator.directive';
import {passwordStrengthValidator} from '../../../validators/password-strength-validator.directive';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  @Input()
  changingExpiredPassword: boolean;

  changePasswordForm: FormGroup;
  errorMessage: any;
  successMessage: string;

  @Output()
  passwordChanged = new EventEmitter<boolean>();

  constructor(private formBuilder: FormBuilder, private userService: UserService) {
  }

  ngOnInit() {
    this.createForm();
  }

  onSubmit() {
    this.errorMessage = null;
    if (this.validateForm()) {
      this.userService.changePassword(this.changePasswordForm.getRawValue().currentPassword, this.changePasswordForm.getRawValue().newPassword, this.changingExpiredPassword).subscribe(data => {
      }, error => {
        this.createForm();
        this.errorMessage = error;
      }, () => {
        this.createForm();
        this.successMessage = 'Password Changed Successfully.';
        if (this.changingExpiredPassword) {
          this.passwordChanged.emit(true);
        }
      });

    }
  }

  private validateForm(): boolean {
    if (this.changePasswordForm.getRawValue().newPassword !== this.changePasswordForm.getRawValue().verifyNewPassword) {
      this.errorMessage = {
        message: 'New Passwords Do not Match'
      };
      this.changePasswordForm.setErrors({invalid: true});
      return false;
    }

    return true;
  }

  private createForm() {
    this.errorMessage = null;
    this.successMessage = '';
    this.changePasswordForm = this.formBuilder.group({
      currentPassword: new FormControl('', [requiredFieldValidator]),
      newPassword: new FormControl('', [requiredFieldValidator, passwordStrengthValidator]),
      verifyNewPassword: new FormControl('', [requiredFieldValidator]),
    });
  }

  cancel() {
    this.createForm();
    if (this.changingExpiredPassword) {
      this.passwordChanged.emit(false);
    }
  }
}
